import React, { useState } from "react";
import { Facility, FacilityType, rng, stringUtil } from "../../amorg-common";
import { AmorgMenu, AmorgMenuContent } from "../../designSystem/amorgMenu";
import { Card } from "../../designSystem/Card";
import { createFacility } from '../../api/locationClientApi';
import { FacilityEditor } from "./FacilityEditor";
import { LoadingPageOverlay } from "../../designSystem/LoadingPageOverlay";
import { Modal } from "../../designSystem/Modal";
import { getFacilityTypeIcon } from '../../utils/facilityHelper';

type FacilityListProps = {
    locationId: string,
    facilities:Facility[],
    allFacilityTypes:FacilityType[],
    onUpdated:()=>Promise<void>
}
export default function FacilityList(props:FacilityListProps):JSX.Element
{
    const [loading, setLoading] = useState(false);
    const [inEditId, setInEditId] = useState('');

    async function handleFacilityUpdated()
    {
        await props.onUpdated();
    }

    async function handleFacilityDeleted()
    {
        await props.onUpdated();
        setInEditId('');
    }

    async function handleFacilityClose(){
        setInEditId('');
    }

    async function handleCreateFacility(){
        
        setLoading(true);

        const nextId = rng.getRandomId();
        const nameBase = 'Ny facilitet';
        const nextName = stringUtil.generateNextSequenceName(nameBase, props.facilities.map(fa => fa.name));
        const result = await createFacility(nextId, nextName, "", "", "other", props.locationId);

        if(result.isSuccess){
            await props.onUpdated();
            setInEditId(nextId);
        }
        setLoading(false);
    }

    async function handleClickFacility(facilityId){
        setInEditId(facilityId)
    }
    
    const menuItems:AmorgMenuContent[] = props.facilities.map(fa  => {
        
        let itm:AmorgMenuContent | undefined = undefined;
        
        itm = {
                
                type: 'leadingTrailingContent',
                onClick: () => handleClickFacility(fa.id),
                leadingContent: { type: 'icon', iconName: getFacilityTypeIcon(fa.facilityType.id) },
                primaryContent: { type:'textWithSubtext', text: fa.name , subtext:fa.facilityType.name},
                trailingContent: { type:'text', text: fa.owner?.name, flex: "1"},
                styleVariant: status === "alert" ? "destructive" : "default"
                
            }
        
        return itm;
    });
        
        
    const facilityView: AmorgMenuContent[] = 
    [
        { 
            type: "label", 
            text: props.facilities.length === 0 ? 
                "Ingen faciliteter oprettet" : 
                "Faciliteter"
        },
        ...menuItems,
        { type: "separator" },
        {
            onClick: () => handleCreateFacility(),
            type: 'leadingContent',
            leadingContent: { type: 'icon', iconName: 'actions_plus' },
            primaryContent: { type: 'text', text: 'Opret ny facilitet' },
            styleVariant: 'emphasized'
        }
    ];
    
    // May be undefined
    const inEditFacility = inEditId ? props.facilities.find(x => x.id === inEditId) : undefined;

    return (
        <>
        <LoadingPageOverlay loading={loading} />
        {props.facilities &&
            <>
            <Card>
                
                <AmorgMenu content={facilityView} />
                
            </Card>

            <Modal 
                title={"Rediger facilitet"}
                content={
                    <FacilityEditor
                        facility={inEditFacility}
                        allFacilityTypes={props.allFacilityTypes}
                        onFacilityUpdated={handleFacilityUpdated}
                        onFacilityDeleted={handleFacilityDeleted}
                        onFacilityClose={handleFacilityClose}
                    />
                }
                showModal={inEditId!=='' && inEditFacility!==undefined}
                onCancel={handleFacilityClose}/>
            
            </>
            }
        </>
    );
 }